var cilCopy = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='408 432 376 432 376 464 112 464 112 136 144 136 144 104 80 104 80 496 408 496 408 432' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M176,16V400H496V153.373L358.627,16ZM464,368H208V48H312V200H464Zm0-200H344V48h1.372L464,166.627Z' class='ci-primary'/>"];

export { cilCopy };

